import { z } from 'zod'

export type AttributesEmbed = {
  src: string
  caption?: string
  alt?: string
}
export const attributesEmbedSchema = z.object({
  src: z.string(),
  caption: z.string().default('').optional(),
  alt: z.string().default(''),
}) satisfies z.ZodType<AttributesEmbed>
